import { render, staticRenderFns } from "./approvePlugin.vue?vue&type=template&id=7553e5f5"
import script from "./approvePlugin.vue?vue&type=script&lang=js"
export * from "./approvePlugin.vue?vue&type=script&lang=js"
import style0 from "./approvePlugin.vue?vue&type=style&index=0&id=7553e5f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports